import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { JWTTokenService } from '../services/jwt-token'
import { authorizationRequest } from './auth-request.helper'

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  constructor(private jwtTokenService: JWTTokenService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.jwtTokenService.get()?.access_token

    if (this.checkCrossOrigin(req)) {
      return next.handle(req)
    }

    if (!accessToken) {
      return next.handle(req)
    }

    const request = authorizationRequest(req, accessToken)
    return next.handle(request)
  }

  private checkCrossOrigin(req: HttpRequest<any>): boolean {
    let host: string | null
    try {
      host = new URL(req.url)?.host
    } catch (e) {
      host = null
    }
    return host !== null && host !== window.location.host
  }
}
